import type { DefaultTheme } from 'styled-components';
import colors from './colors';

type ThemedProps = { theme?: DefaultTheme };

export const actionColor = ({ theme }: ThemedProps) => theme?.actionColor || colors.action;
export const actionLight = ({ theme }: ThemedProps) => theme?.actionLight || colors.actionLight;
export const actionColorDark = ({ theme }: ThemedProps) => theme?.actionColorDark || colors.actionColorDark;
export const inputBorderColor = ({ theme }: ThemedProps) => theme?.inputBorderColor || colors.gray300;
